/* eslint-disable */
// @ts-nocheck
import { Flag } from './Flag';
import { FlagCreationOptions } from './FlagCreationOptions';
import { Provider } from '../base/Provider';

/**
 * Products must implement this interface in order to inject flag bahaviour into
 * the Connect framework.
 */
export interface FlagProvider extends Provider {
	create(options: FlagCreationOptions): Flag;

	isFlagOpen(flagId: string): boolean;
}
